type Subscriber<T> = (value: T | undefined) => void;
export type Unsubscriber = () => void;

export interface Observable<T> {
  subscribe: (subscriber: Subscriber<T>) => Unsubscriber;
  unsubscribe: (subscriber: Subscriber<T>) => void;
  getValue: () => T | undefined;
}

export class MutableObservable<T> implements Observable<T> {
  private subscribers: Set<Subscriber<T>> = new Set();
  private value: T | undefined;

  constructor(initialValue?: T) {
    this.value = initialValue;
  }

  subscribe(subscriber: Subscriber<T>): Unsubscriber {
    this.subscribers.add(subscriber);
    subscriber(this.value);

    return () => {
      this.unsubscribe(subscriber);
    };
  }

  unsubscribe(subscriber: Subscriber<T>): void {
    this.subscribers.delete(subscriber);
  }

  notify(): void {
    for (const subscriber of this.subscribers) {
      subscriber(this.value);
    }
  }

  setValue(newValue: T): void {
    this.value = newValue;
    this.notify();
  }

  getValue(): T | undefined {
    return this.value;
  }
}
